import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Use the same axios instance everywhere — sends cookies + bearer if set.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let _token = localStorage.getItem("gc_token") || null;

export function setAuthToken(token) {
  _token = token || null;
  if (token) localStorage.setItem("gc_token", token);
  else localStorage.removeItem("gc_token");
}

api.interceptors.request.use((config) => {
  if (_token) config.headers.Authorization = `Bearer ${_token}`;
  return config;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
